import { supabaseClient } from "supabase/supabase";

export type DeleteEventsParams = {
  uids: string[];
};

export const deleteEvents = async ({ uids }: DeleteEventsParams) => {
  const query = supabaseClient.from("events").delete().in("uid", uids);

  const { error } = await query;
  if (error) {
    throw error;
  }
  return null;
};
